/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Cmp_SubtitleInputs */

const en_pc_cmp_subtitle = /** @type {(inputs: Pc_Cmp_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A free, open-source workbench against the most complete PDF suite money can buy.`)
};

const zh_pc_cmp_subtitle = /** @type {(inputs: Pc_Cmp_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`免费开源的 PDF 工作台，对上花钱能买到的最完整 PDF 套件。`)
};

/**
* | output |
* | --- |
* | "A free, open-source workbench against the most complete PDF suite money can buy." |
*
* @param {Pc_Cmp_SubtitleInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_cmp_subtitle = /** @type {((inputs?: Pc_Cmp_SubtitleInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Cmp_SubtitleInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_cmp_subtitle(inputs)
	return zh_pc_cmp_subtitle(inputs)
});
export { pc_cmp_subtitle as "pc.cmp.subtitle" }